

const firebaseConfig = {
  apiKey: "AIzaSyCD8a3XpVypeE5uadRmFoYNsCfDL8GAu7A",
  authDomain: "arclif-backend.firebaseapp.com",
  databaseURL: "https://arclif-backend.firebaseio.com",
  projectId: "arclif-backend",
  storageBucket: "arclif-backend.appspot.com",
  messagingSenderId: "249966388972",
  appId: "1:249966388972:web:3c25365224e038f3da27c9",
  measurementId: "G-K419MCRN90"
}

export default firebaseConfig